import { ContactForm } from "~/components/contact-form"
import { contactFormSchema } from "~/schema/contact"
import { parseWithZod } from "@conform-to/zod"
import { sendMessageToEnquiriesChannel } from "~/utils/discord.server"

export const meta = () => {
  const TITLE = "GOODWERK | Contact Us"
  const DESCRIPTION =
    "We consult and build practical websites and solutions for business needs of any size."
  const IMAGE_PATH = "/assets/goodwerk-makes-effective-websites.png"

  return [
    { title: TITLE },
    {
      name: "description",
      content: DESCRIPTION,
    },
    { property: "og:title", content: TITLE },
    { property: "og:description", content: DESCRIPTION },
    { property: "og:image", content: IMAGE_PATH },
    { name: "twitter:title", content: TITLE },
    { name: "twitter:description", content: DESCRIPTION },
    { name: "twitter:image", content: IMAGE_PATH },
  ]
}

export const action = async ({ request }) => {
  const formData = await request.formData()

  const submission = parseWithZod(formData, { schema: contactFormSchema })
  if (submission.status !== "success") {
    return submission.reply()
  }

  const sendMessage = sendMessageToEnquiriesChannel({
    message: `New enquiry!\n\n ${JSON.stringify(submission.value, null, "\t")}`,
  })

  return submission.reply()
}

export default function Contact() {
  return (
    <div className="flex max-h-svh w-full flex-col justify-center px-6 py-36">
      {/* <SubHeadline>{`We'll be in touch within 24 hours`}</SubHeadline> */}
      <ContactForm />
      <p className="mt-4 text-center font-medium">
        You can also reach us at{" "}
        <span className="tracking-wide text-blue-500">contact@goodwerk.io</span>
      </p>
    </div>
  )
}
